<template>
  <div class="index-page">
    <div class="download-box" v-if="download_show">
      <div class="download-left">
        <img src="/static/image/new/index/Safari-close.png" class="close-img" @click="hideDownLoad()"  alt="">
        <div class="download-info">
          <img src="/static/image/new/index/Safari-logo1.png" class="logo" alt="">
          <div>
            <div class="title">{{ $t('软件APP') }}</div>
            <div class="star-info">
              <div class="star-list">
                <img src="/static/image/new/index/Star-icon.png" alt="">
                <img src="/static/image/new/index/Star-icon.png" alt="">
                <img src="/static/image/new/index/Star-icon.png" alt="">
                <img src="/static/image/new/index/Star-icon.png" alt="">
                <img src="/static/image/new/index/Star-icon.png" alt="">
              </div>
              5.0
            </div>
            <div class="desc">{{ $t('按照') }} <img src="/static/image/new/index/Safari-logo2.png" alt="">{{ $t('到您的桌面') }}</div>
          </div>
        </div>
      </div>
      <div class="download-btn" @click="Safari_show = true; hideDownLoad()">{{ $t('安装') }}</div>
    </div>
    <div class="content">
      <div class="banner-box" v-if="bannerList.length > 0">
         <div class="swiper-list" >
          <div class="swiper-container bannerSwiper">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(item, index) in bannerList" :key="index">
                <img :src="imgBase + item.src" class="banner-img" alt="">
<!--                <div class="banner-info">-->
<!--                  <div class="banner-title">WELCOME TO NG28.GAME</div>-->
<!--                  <div class="banner-desc">Play Now Became a Winner</div>-->
<!--                </div>-->
              </div>

            </div>

          </div>
          <div class="swiper-controls">
<!--            <div class="swiper-button-prev custom-prev"></div>-->
            <div class="swiper-pagination"></div>
<!--            <div class="swiper-button-next custom-next"></div>-->
          </div>
        </div>
         <div class="header-box">
<!--           <img class="logo" src="/static/image/new/logo-img.png">-->
           <div></div>
           <div class="btn-box" v-if="!$store.state.token">
            <div class="btn-item">
              <div class="btn" @click="$parent.goNav('/reg2')">{{ $t('注册') }}</div>
            </div>
            <div class="btn-item login-btn">
              <div class="btn" @click="$parent.goNav('/login')">{{ $t('登录') }}</div>
            </div>
          </div>
           <div class="user-box" v-else>
             <div class="balance-info" @click="$parent.goNav('/recharge')">
               {{ $store.state.userInfo.balance }}
               <img src="/static/image/new/index/home-add-img.png" class="icon" alt="">
             </div>
             <img :src="$store.state.userInfo.avatar ? $store.state.userInfo.avatar : '/static/image/imageAvatar02@3x.png'" class="avatar" alt="">
           </div>
        </div>
      </div>
      <div class="menu-list">
        <!--          <div class="menu-item" @click="$parent.goNav('/recharge')">-->
        <!--            <img src="/static/image/new/index/menu-bg-img1.png" alt="">-->
        <!--            <span>存款</span>-->
        <!--          </div>-->
        <!--          <div class="menu-item" @click="$parent.goNav('/withdrawal')">-->
        <!--            <img src="/static/image/new/index/menu-bg-img2.png" alt="">-->
        <!--            <span>提款</span>-->
        <!--          </div>-->
        <!--          <div class="menu-item" @click="$parent.goNav('/vip2')">-->
        <!--            <img src="/static/image/new/index/menu-bg-img3.png" alt="">-->
        <!--            <span>贵宾</span>-->
        <!--          </div>-->
        <!--          <div class="menu-item" @click="$parent.goNav('/transfer')">-->
        <!--            <img src="/static/image/new/index/menu-bg-img4.png" alt="">-->
        <!--            <span>转移</span>-->
        <!--          </div>-->

<!--        <div class="menu-item" style="background-image: url('/static/image/new/index/home-menu-bg1.png')" @click="$router.push({path: '/game-list', query: {game_video: 'jld28', room: 'one'}})">-->
        <div class="menu-item" style="background-image: url('/static/image/new/index/home-menu-bg1.png')" @click="handleHomeMenuClick('pc28')">
          <img src="/static/image/new/index/home-menu-img1.png" alt="">
          <span>{{ $t('PC28') }}</span>
        </div>
<!--        <div class="menu-item" style="background-image: url('/static/image/new/index/home-menu-bg3.png')" @click="go2('PG', 'PG')">-->
<!--        <div class="menu-item" style="background-image: url('/static/image/new/index/home-menu-bg6.png')" @click="handleHomeMenuClick('liuhe')">-->
        <div class="menu-item" style="background-image: url('/static/image/new/index/home-menu-bg6.png')" @click="handleHomeMenuClick('comingSoon')">
          <img src="/static/image/new/index/home-menu-img6.png" alt="">
          <span>{{ $t('六合彩') }}</span>
        </div>
        <div class="menu-item" style="background-image: url('/static/image/new/index/home-menu-bg3.png')" @click="handleHomeMenuClick('comingSoon')">
          <img src="/static/image/new/index/home-menu-img3.png" alt="">
          <span>{{ $t('电子') }}</span>
        </div>
<!--        <div class="menu-item" style="background-image: url('/static/image/new/index/home-menu-bg4.png')" @click="go2('FB', 'FB')">-->
        <div class="menu-item" style="background-image: url('/static/image/new/index/home-menu-bg4.png')" @click="handleHomeMenuClick('comingSoon')">
          <img src="/static/image/new/index/home-menu-img4.png" alt="">
          <span>{{ $t('体育') }}</span>
        </div>
<!--        <div class="menu-item" style="background-image: url('/static/image/new/index/home-menu-bg5.png')" @click="go2('AG', 'AG')">-->
        <div class="menu-item" style="background-image: url('/static/image/new/index/home-menu-bg5.png')" @click="handleHomeMenuClick('comingSoon')">
          <img src="/static/image/new/index/home-menu-img5.png" alt="">
          <span>{{ $t('真人') }}</span>
        </div>
<!--        <div class="menu-item" style="background-image: url('/static/image/new/index/home-menu-bg2.png')" @click="go2('KY','KY')">-->
        <div class="menu-item" style="background-image: url('/static/image/new/index/home-menu-bg2.png')" @click="handleHomeMenuClick('comingSoon')">
          <img src="/static/image/new/index/home-menu-img2.png" alt="">
          <span>{{ $t('棋牌') }}</span>
        </div>
<!--        <div class="menu-item" style="background-image: url('/static/image/new/index/home-menu-bg6.png')" @click="$router.push({path: '/game-Liuhe', query: {game_video: 'xamlhc', name: '新澳门六合彩', room: 'one'}})">-->
      </div>
      <div class="card-box-bg">
<!--        <div class="notice-content">-->
<!--          <img src="/static/image/new/index/msg-icon.png" class="icon"/>-->
<!--          <div class="notice-list">-->
<!--            <van-notice-bar color="#535a73" scrollable>-->
<!--              <span-->
<!--              v-for="(item, index) in homeNoticeList"-->
<!--              :key="index"-->
<!--              class="notice-text"-->
<!--            >{{ item }}</span-->
<!--            >-->
<!--            </van-notice-bar>-->
<!--          </div>-->
<!--        </div>-->
        <div class="balance-container">
          <div class="account">{{ $store.state.userInfo.username || $t('请先登录') }}</div>
          <div class="balance">
            {{ $store.state.userInfo.balance || 0 }}
            <img src="/static/image/new/index/refresh-icon.png" class="refresh-icon" alt="">
          </div>
        </div>
      </div>

      <div class="game-nav-list">
        <div :class="{'nav-item': true, 'active': nav_type === item.type}" v-for="(item,index) in nav_list" :key="index" @click="clickTab(item.type)">
          <img :src="nav_type === item.type ? item.icon_active : item.icon" alt="">
          {{ $t(item.title) }}
        </div>
      </div>
      <template >
        <div v-show="nav_type === 1" class="game-nav-content">
          <div class="game-nav-title">{{ $t('MI28') }}</div>
          <div class="game-nav-desc">{{ $t('澳门六合彩') }}</div>
          <img src="/static/image/new/index/lottery_bg2_img.png" class="lottery_bg2_img" alt="">
          <div class="room-list-wrapper" @click="handleClick">
            <div class="swiper-container room-list">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item,index) in rooms_list" :key="index">
                  <div class="room-item" :data-type="item.type" :data-room="item.code">
                    <img :src="item.img" class="bg" alt="">
                    <div class="room-info">
                <div class="room-name">{{ item.titleKey }} {{item.min}}{{ $t('分钟') }}</div>
                      <div class="money">$<span>{{ item.money }}</span>{{ $t('万美元') }}</div>
                      <div class="countdown" :data-room="item.code">
                        <span class="block hours">{{ getRoomCountdown(item).hours }}</span>
                        <span class="colon">:</span>
                        <span class="block minutes">{{ getRoomCountdown(item).minutes }}</span>
                        <span class="colon">:</span>
                        <span class="block seconds">{{ getRoomCountdown(item).seconds }}</span>
<!--                        <van-count-down :time="totalSeconds3" @change="onCountDownChange3">-->
<!--                          <template #default="timeData">-->
<!--                            <span class="block">{{ String(timeData.hours).padStart(2, '0') }}</span>-->
<!--                            <span class="colon">:</span>-->
<!--                            <span class="block">{{ String(timeData.minutes).padStart(2, '0') }}</span>-->
<!--                            <span class="colon">:</span>-->
<!--                            <span class="block">{{ String(timeData.seconds).padStart(2, '0') }}</span>-->
<!--                          </template>-->
<!--                        </van-count-down>-->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-show="nav_type === 1" class="swiper-banner-container">
          <div class="banner-title">{{ $t('澳门六合彩') }}</div>
          <div class="banner-desc">{{ $t('现在就成为赢家') }}</div>
<!--          <div class="swiper-box" @click="$router.push({path: '/game-Liuhe', query: {game_video: 'xamlhc', name: $t('新澳门六合彩'), room: 'one'}})">-->
          <div class="swiper-box" @click="handleHomeMenuClick('comingSoon')">
            <img src="/static/image/new/index/banner-swiper-img2.png" class="cover" alt="">
            <div class="swiper-info">
              <div class="left">
                <div class="title">{{ $t('马克六号彩票') }}</div>
                <div class="desc">{{ $t('现在就成为赢家') }}</div>
              </div>
              <div class="btn">{{ $t('开始') }}</div>
            </div>
            <div class="swiper-list">
              <div :class="{'swiper-item': true, 'active': index === swiper_nav_index}" v-for="(item,index) in 5" :key="index" @click.stop="swiper_nav_index = index">
                <img :src="`/static/image/new/index/swiper-nav-img${index+1}.png`" alt="">
              </div>
            </div>
          </div>

        </div>
      </template>
      <div class="nav-banner-content">
<!--        <ul v-if="nav_type === 1">-->
<!--          <li @click="$router.push({path: '/game-list', query: {game_video: 'jld28', room: 'one'}})"><img src="/static/image/new/index/pc-banner1.png" alt=""></li>-->
<!--          <li @click="$router.push({path: '/game-Liuhe', query: {game_video: 'xamlhc', name: '新澳门六合彩', room: 'one'}})"><img src="/static/image/new/index/pc-banner2.png" alt=""></li>-->
<!--          <li @click="$router.push({path: '/game-Liuhe', query: {game_video: 'lamlhc', name: '澳门六合彩', room: 'one'}})"><img src="/static/image/new/index/pc-banner3.png" alt=""></li>-->
<!--        </ul>-->
        <ul v-if="nav_type === 2">
          <li class="localized-image-banner" @click="go2('AG', 'AG')"><img src="/static/image/new/index/realp-banner1.png" alt=""><div class="localized-image-copy"><strong>{{ $t('真人') }}</strong><span>{{ $t('AG真人') }}</span><em>{{ $t('进入游戏') }}</em></div></li>
          <li class="localized-image-banner" @click="go2('BG', 'BG')"><img src="/static/image/new/index/realp-banner2.png" alt=""><div class="localized-image-copy"><strong>{{ $t('真人') }}</strong><span>{{ $t('BG真人') }}</span><em>{{ $t('进入游戏') }}</em></div></li>
<!--          <li @click="go2('BG', 'BG')"><img src="/static/image/new/index/realp-banner3.png" alt=""></li>-->
        </ul>
        <ul v-else-if="nav_type === 3">
          <li class="localized-image-banner" @click="go2('PG', 'PG')"><img src="/static/image/new/index/electronic-banner1.png" alt=""><div class="localized-image-copy"><strong>{{ $t('电子') }}</strong><span>{{ $t('PG电子') }}</span><em>{{ $t('进入游戏') }}</em></div></li>
          <li class="localized-image-banner" @click="go2('AGDZ', 'AGDZ')"><img src="/static/image/new/index/electronic-banner2.png" alt=""><div class="localized-image-copy"><strong>{{ $t('电子') }}</strong><span>{{ $t('AG电子') }}</span><em>{{ $t('进入游戏') }}</em></div></li>
        </ul>
        <ul v-else-if="nav_type === 4">
          <li class="localized-image-banner" @click="go2('FB', 'FB')"><img src="/static/image/new/index/physical-banner1.png" alt=""><div class="localized-image-copy"><strong>{{ $t('体育') }}</strong><span>{{ $t('FB体育') }}</span><em>{{ $t('进入游戏') }}</em></div></li>
        </ul>
        <ul v-else-if="nav_type === 5">
          <li class="localized-image-banner" @click="go2('KY','KY')"><img src="/static/image/new/index/KY-banner1.png" alt=""><div class="localized-image-copy"><strong>{{ $t('棋牌') }}</strong><span>{{ $t('KY棋牌') }}</span><em>{{ $t('进入游戏') }}</em></div></li>
        </ul>
      </div>

      <!--   最新投注   -->
<!--      <div class="new-bet-container" v-if="$store.state.appInfo.is_winning == 1">-->
      <div class="new-bet-container" v-if="false">
        <div class="container-title">{{ $t('最新投注') }}</div>
        <div class="container-desc">{{ $t('最新投注') }}</div>
        <div class="bet-tab">
          <div :class="{'tab-item': true, 'active': bet_type === item.type}" v-for="(item,index) in bet_tab" :key="index" @click="bet_type = item.type">
            {{ $t(item.titleKey) }}
          </div>
        </div>
        <div class="bet-table">
          <div class="table-head tr">
            <div class="td">{{ $t('游戏') }}</div>
            <div class="td">{{ $t('玩家') }}</div>
            <div class="td">{{ $t('倍数') }}</div>
            <div class="td">{{ $t('返奖') }}</div>
          </div>
          <!--          <div class="table-content">-->
          <!--            <div class="tr" v-for="(item, index) in bet_list[bet_type]" :key="index">-->
          <!--              <div class="td">-->
          <!--                <div class="game-name-box">-->
          <!--                  <img src="/static/image/new/index/game-logo1.png" class="icon" alt="">-->
          <!--                  <div class="name">{{ item.youxiname }}</div>-->
          <!--                </div>-->
          <!--              </div>-->
          <!--              <div class="td">-->
          <!--                {{ item.username }}-->
          <!--              </div>-->
          <!--              <div class="td">-->
          <!--                {{ item.beishu }}-->
          <!--              </div>-->
          <!--              <div class="td">-->
          <!--                <div class="rebate-box">-->
          <!--                  <div class="value">-{{ item.fanjiang }}</div>-->
          <!--                  <img src="/static/image/new/applyagen-icon.png" class="icon" alt="">-->
          <!--                </div>-->
          <!--              </div>-->

          <!--            </div>-->
          <!--          </div>-->

          <div class="table-wrapper">
            <div
              class="table-content"
              ref="scrollBox"
              @mouseenter="pauseScroll"
              @mouseleave="startScroll"
            >
              <div class="scroll-list" ref="list1">
                <div class="tr" v-for="(item, index) in bet_list[bet_type]" :key="'a'+index">
                  <div class="td">
                    <div class="game-name-box">
                      <img src="/static/image/new/index/game-logo1.png" class="icon" />
                      <div class="name">{{ item.youxiname }}</div>
                    </div>
                  </div>
                  <div class="td">{{ item.username }}</div>
                  <div class="td">{{ item.beishu }}</div>
                  <div class="td">
                    <div class="rebate-box">
                      <div class="value">-{{ item.fanjiang }}</div>
                      <img src="/static/image/new/applyagen-icon.png" class="icon" />
                    </div>
                  </div>
                </div>
              </div>

              <!-- 克隆一份用于无缝滚动 -->
              <div class="scroll-list" ref="list2">
                <div class="tr" v-for="(item, index) in bet_list[bet_type]" :key="'b'+index">
                  <div class="td">
                    <div class="game-name-box">
                      <img src="/static/image/new/index/game-logo1.png" class="icon" />
                      <div class="name">{{ item.youxiname }}</div>
                    </div>
                  </div>
                  <div class="td">{{ item.username }}</div>
                  <div class="td">{{ item.beishu }}</div>
                  <div class="td">
                    <div class="rebate-box">
                      <div class="value">-{{ item.fanjiang }}</div>
                      <img src="/static/image/new/applyagen-icon.png" class="icon" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!--   真人   -->
      <div class="game-type-container">
        <div class="container-head-box">
          <div class="title">{{ $t('真人') }}</div>
          <div></div>
          <div class="more-box" @click="jumpGameHall('realbet')">
            {{ $t('更多') }}
            <van-icon name="arrow"/>
          </div>
        </div>
        <div class="game-list game-list2">
          <div class="game-item">
            <div class="cover" @click="go2('AG', 'AG')">
              <img src="/static/image/new/index/game-cover-img1.png" alt="">
              <div class="hot">{{ $t('热门') }}</div>
              <div class="title">{{ $t('经典') }}<br/>{{ $t('百家乐') }}</div>
            </div>
            <div class="collect-info">
              <img src="/static/image/new/index/collect-icon.png" alt="" class="icon">
              503
            </div>
          </div>
          <div class="game-item">
            <div class="cover" @click="go2('BG', 'BG')">
              <img src="/static/image/new/index/game-cover-img2.png" alt="">
              <div class="title">{{ $t('快速') }}<br/>{{ $t('百家乐') }}</div>
            </div>
            <div class="collect-info">
              <img src="/static/image/new/index/collect-icon.png" alt="" class="icon">
              503
            </div>
          </div>
          <div class="game-item">
            <div class="cover" @click="go2('AG', 'AG')">
              <img src="/static/image/new/index/game-cover-img3.png" alt="">
              <div class="title">{{ $t('经典') }}<br/>{{ $t('百家乐') }}</div>
            </div>
            <div class="collect-info">
              <img src="/static/image/new/index/collect-icon.png" alt="" class="icon">
              503
            </div>
          </div>
        </div>
      </div>
      <!--   电子   -->
      <div class="game-type-container boxShadow2">
        <div class="container-head-box">
          <div class="title">{{ $t('电子') }}</div>
          <div></div>
          <div class="more-box" @click="jumpGameHall('concise')">
            {{ $t('更多') }}
            <van-icon name="arrow"/>
          </div>
        </div>
        <div class="game-list">
          <div class="game-item">
            <div class="cover" @click="go2('PG', 'PG')">
              <img src="/static/image/new/index/game-cover-img4.png" alt="">
              <div class="hot">{{ $t('热门') }}</div>
              <div class="title">{{ $t('大富翁') }}</div>
            </div>
            <div class="collect-info">
              <img src="/static/image/new/index/collect-icon.png" alt="" class="icon">
              91
            </div>
          </div>
          <div class="game-item">
            <div class="cover" @click="go2('AGDZ', 'AGDZ')">
              <img src="/static/image/new/index/game-cover-img5.png" alt="">
              <div class="title">{{ $t('财神驾到') }}</div>
            </div>
            <div class="collect-info">
              <img src="/static/image/new/index/collect-icon.png" alt="" class="icon">
              8
            </div>
          </div>
          <div class="game-item">
            <div class="cover" @click="go2('PG', 'PG')">
              <img src="/static/image/new/index/game-cover-img9.png" alt="">
              <div class="title">{{ $t('红包派对') }}</div>
            </div>
            <div class="collect-info">
              <img src="/static/image/new/index/collect-icon.png" alt="" class="icon">
              8
            </div>
          </div>
        </div>
      </div>
      <div class="game-type-container boxShadow3">
        <div class="container-head-box">
          <div class="title">{{ $t('体育') }}</div>
          <div></div>
          <div class="more-box" @click="jumpGameHall('sport')">
            {{ $t('更多') }}
            <van-icon name="arrow"/>
          </div>
        </div>
        <div class="game-list">
          <div class="game-item">
            <div class="cover" @click="go2('FB', 'FB')">
              <img src="/static/image/new/index/game-cover1.png" alt="">
              <div class="title">{{ $t('沙巴体育') }}</div>
            </div>
            <div class="collect-info">
              <img src="/static/image/new/index/collect-icon.png" alt="" class="icon">
              503
            </div>
          </div>
          <div class="game-item">
            <div class="cover" @click="go2('FB', 'FB')">
              <img src="/static/image/new/index/game-cover2.png" alt="">
              <div class="title">{{ $t('UP体育') }}</div>
            </div>
            <div class="collect-info">
              <img src="/static/image/new/index/collect-icon.png" alt="" class="icon">
              232
            </div>
          </div>
          <div class="game-item">
            <div class="cover" @click="go2('FB', 'FB')">
              <img src="/static/image/new/index/game-cover3.png" alt="">
              <div class="title">{{ $t('沙巴体育') }}</div>
            </div>
            <div class="collect-info">
              <img src="/static/image/new/index/collect-icon.png" alt="" class="icon">
              43
            </div>
          </div>
        </div>
      </div>
      <div class="poker-container">
        <div class="container-head-box">
          <div class="title">{{ $t('德州扑克') }}</div>
          <div></div>
        </div>
        <div class="poker-banner-img" @click="toast($t('即将上线，敬请期待'))">
          <img src="/static/image/new/index/poker-banner-img.png" alt="">
          <div class="title">{{ $t('德州扑克') }}</div>
        </div>
      </div>
      <div class="game-type-container boxShadow">
        <div class="container-head-box">
          <div class="title">{{ $t('棋牌') }}</div>
          <div></div>
          <div class="more-box" @click="jumpGameHall('joker')">
            {{ $t('更多') }}
            <van-icon name="arrow"/>
          </div>
        </div>
        <div class="game-list">
          <div class="game-item">
            <div class="cover" @click="go2('KY', 'KY')">
              <img src="/static/image/new/index/game-cover-img6.png" alt="">
              <div class="hot">{{ $t('热门') }}</div>
              <div class="title">{{ $t('21点') }}</div>
            </div>
            <div class="collect-info">
              <img src="/static/image/new/index/collect-icon.png" alt="" class="icon">
              80
            </div>
          </div>
          <div class="game-item">
            <div class="cover" @click="go2('KY', 'KY')">
              <img src="/static/image/new/index/game-cover-img7.png" alt="">
              <div class="title">{{ $t('抢庄牛牛') }}</div>
            </div>
            <div class="collect-info">
              <img src="/static/image/new/index/collect-icon.png" alt="" class="icon">
              101
            </div>
          </div>
          <div class="game-item">
            <div class="cover" @click="go2('KY', 'KY')">
              <img src="/static/image/new/index/game-cover-img8.png" alt="">
              <div class="title">{{ $t('21点') }}</div>
            </div>
            <div class="collect-info">
              <img src="/static/image/new/index/collect-icon.png" alt="" class="icon">
              78
            </div>
          </div>
        </div>
      </div>
      <div class="game-lottery-container">
        <div class="container-head-box">
          <div class="title">{{ $t('彩票') }}</div>
          <div></div>

        </div>
        <div class="lottery-list">
          <div class="lottery-item" style="background-image: url('/static/image/new/index/lottery-item-bg1.png')">
            <div class="info">
              <img src="/static/image/new/index/lottery-icon1.png" class="logo" alt="">
              <div>
                <div class="title">{{ $t('新澳门六合彩') }}</div>
                <div class="num">{{ $t('第') }} {{ sequence_info1.sequencenum + 1 }} {{ $t('期') }}</div>
              </div>
            </div>
            <div class="start-time-title">{{ $t('开奖时间') }}</div>
            <div class="countDown">
              <van-count-down :time="totalSeconds1" @change="onCountDownChange1">
                <template #default="timeData">
                  <span class="block-bg">
                    <span class="block">{{ String(timeData.hours).padStart(2, '0') }} <em>{{ $t('时') }}</em></span>
                  </span>
                  <span class="colon">:</span>
                  <span class="block-bg">
                    <span class="block">{{ String(timeData.minutes).padStart(2, '0') }} <em>{{ $t('分') }}</em></span>
                  </span>
                  <span class="colon">:</span>
                  <span class="block-bg">
                    <span class="block">{{ String(timeData.seconds).padStart(2, '0') }} <em>{{ $t('秒') }}</em></span>
                  </span>
                </template>
              </van-count-down>
            </div>
<!--            <div class="bet-btn" @click="$router.push({path: '/game-Liuhe', query: {game_video: 'xamlhc', name: $t('新澳门六合彩'), room: 'one'}})">{{ $t('立即投注') }}</div>-->
            <div class="bet-btn" @click="handleHomeMenuClick('comingSoon')">{{ $t('立即投注') }}</div>
          </div>
<!--          <div class="lottery-item" style="background-image: url('/static/image/new/index/lottery-item-bg2.png')">-->
<!--            <div class="info">-->
<!--              <img src="/static/image/new/index/lottery-icon2.png" class="logo" alt="">-->
<!--              <div>-->
<!--                <div class="title">澳门六合彩</div>-->
<!--                <div class="num">第 2025115 期</div>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="start-time-title">开奖时间</div>-->
<!--            <div class="countDown">-->
<!--              <van-count-down :time="totalSeconds2" @change="onCountDownChange2">-->
<!--                <template #default="timeData">-->
<!--                  <span class="block-bg">-->
<!--                    <span class="block">{{ String(timeData.hours).padStart(2, '0') }} <em>时</em></span>-->
<!--                  </span>-->
<!--                  <span class="colon">:</span>-->
<!--                  <span class="block-bg">-->
<!--                    <span class="block">{{ String(timeData.minutes).padStart(2, '0') }} <em>分</em></span>-->
<!--                  </span>-->
<!--                  <span class="colon">:</span>-->
<!--                  <span class="block-bg">-->
<!--                    <span class="block">{{ String(timeData.seconds).padStart(2, '0') }} <em>秒</em></span>-->
<!--                  </span>-->
<!--                </template>-->
<!--              </van-count-down>-->
<!--            </div>-->
<!--            <div class="bet-btn" @click="$router.push({path: '/game-Liuhe', query: {game_video: 'lamlhc', name: '澳门六合彩', room: 'one'}})">立即投注</div>-->
<!--          </div>-->
          <div class="lottery-item" style="background-image: url('/static/image/new/index/lottery-item-bg2.png')">
            <div class="info">
              <img src="/static/image/new/index/lottery-icon2.png" class="logo" alt="">
              <div>
                <div class="title">{{ $t('香港六合彩') }}</div>
                <div class="num">{{ $t('第') }} {{ sequence_info2.sequencenum + 1 }} {{ $t('期') }}</div>
              </div>
            </div>
            <div class="start-time-title">{{ $t('开奖时间') }}</div>
            <div class="countDown">
              <van-count-down :time="totalSeconds2" @change="onCountDownChange2">
                <template #default="timeData">
                  <span class="block-bg">
                    <span class="block">{{ String(timeData.hours).padStart(2, '0') }} <em>{{ $t('时') }}</em></span>
                  </span>
                  <span class="colon">:</span>
                  <span class="block-bg">
                    <span class="block">{{ String(timeData.minutes).padStart(2, '0') }} <em>{{ $t('分') }}</em></span>
                  </span>
                  <span class="colon">:</span>
                  <span class="block-bg">
                    <span class="block">{{ String(timeData.seconds).padStart(2, '0') }} <em>{{ $t('秒') }}</em></span>
                  </span>
                </template>
              </van-count-down>
            </div>
<!--            <div class="bet-btn" @click="$router.push({path: '/game-Liuhe', query: {game_video: 'xglhc', name: $t('香港六合彩'), room: 'one'}})">{{ $t('立即投注') }}</div>-->
            <div class="bet-btn" @click="handleHomeMenuClick('comingSoon')">{{ $t('立即投注') }}</div>
          </div>
        </div>
      </div>
      <div class="game-owner-container">
        <div class="container-head-box">
          <div class="title">{{ $t('游戏厂商') }}</div>
          <div></div>
        </div>
        <div class="owner-list">
          <div class="owner-item">
            <div class="more-btn">{{ $t('了解更多') }} ></div>
            <div class="info">
              <img src="/static/image/new/index/owner-title-img.png" class="logo" alt="">
              <div>
                <div class="title">PG GAMING</div>
                <div class="num">{{ $t('183款游戏') }}</div>
              </div>
            </div>
            <div class="cover-list">
              <img src="/static/image/new/index/owner-icon1.png" class="img" alt="">
              <img src="/static/image/new/index/owner-icon2.png" class="img" alt="">
              <img src="/static/image/new/index/owner-icon3.png" class="img" alt="">
              <img src="/static/image/new/index/owner-icon4.png" class="img" alt="">
              <img src="/static/image/new/index/owner-icon5.png" class="img" alt="">
              <img src="/static/image/new/index/owner-icon6.png" class="img" alt="">
            </div>
          </div>
          <div class="owner-item">
            <div class="more-btn">{{ $t('了解更多') }} ></div>
            <div class="info">
              <img src="/static/image/new/index/owner-title-img.png" class="logo" alt="">
              <div>
                <div class="title">GFG GAMING</div>
                <div class="num">{{ $t('183款游戏') }}</div>
              </div>
            </div>
            <div class="cover-list">
              <img src="/static/image/new/index/owner-icon7.png" class="img" alt="">
              <img src="/static/image/new/index/owner-icon8.png" class="img" alt="">
              <img src="/static/image/new/index/owner-icon9.png" class="img" alt="">
              <img src="/static/image/new/index/owner-icon10.png" class="img" alt="">
              <img src="/static/image/new/index/owner-icon11.png" class="img" alt="">
              <img src="/static/image/new/index/owner-icon12.png" class="img" alt="">
            </div>
          </div>
        </div>
      </div>
      <!--   巴沙体育   -->
      <div class="swiper-game-container">
        <div class="swiper-title">{{ $t('巴沙体育') }}</div>
        <div class="swiper-desc">{{ $t('千人在线畅玩') }}</div>
        <div class="swiper-list">
          <div class="swiper-container mySwiper">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <img src="/static/image/new/index/swiper-img1.png" alt="">
              </div>
              <div class="swiper-slide">
                <img src="/static/image/new/index/swiper-img3.png" alt="">
              </div>
              <div class="swiper-slide">
                <img src="/static/image/new/index/swiper-img2.png" alt="">
              </div>
            </div>

          </div>
          <div class="swiper-controls">
            <div class="swiper-button-prev custom-prev"></div>
            <div class="swiper-pagination"></div>
            <div class="swiper-button-next custom-next"></div>
          </div>
        </div>
      </div>
      <div class="detail-container">
        <div class="container-head-box">
          <div class="title">{{ $t('最佳加密货币赌场 - 欢迎来到') }}</div>
          <div></div>
        </div>
        <div :class="{'detail-box': true, 'shadow': !detail_status}">
          <div class="detail-content">
            <p>{{ $t('home-detail-content') }}</p>
          </div>
          <div :class="{'detail-more': true, 'open-more': detail_status}" @click="detail_status = !detail_status">
            <div class="btn">
              {{ detail_status ? $t('收起更多') : $t('查看更多') }}
            </div>
          </div>
        </div>
      </div>
      <div class="law-container">
        <div class="container-head-box">
          <div class="title">{{ $t('支持/法律') }}</div>
          <div></div>
        </div>
        <div class="law-list">
          <div class="law-item">{{ $t('常见问题') }}</div>
          <div class="law-item">{{ $t('负责任博彩') }}</div>
          <div class="law-item">{{ $t('公平公正') }}</div>
          <div class="law-item">{{ $t('服务条款') }}</div>
          <div class="law-item">{{ $t('隐私政策') }}</div>
          <div class="law-item">{{ $t('关于我们') }}</div>
        </div>
      </div>
      <div class="currency-container">
        <div class="container-head-box">
          <div class="title">{{ $t('支持的币种') }}</div>
          <div></div>
        </div>
        <div class="currency-list">
          <img src="/static/image/new/index/currency-icon1.png" class="icon" alt="">
          <img src="/static/image/new/index/currency-icon2.png" class="icon" alt="">
          <img src="/static/image/new/index/currency-icon3.png" class="icon" alt="">
          <img src="/static/image/new/index/currency-icon4.png" class="icon" alt="">
          <img src="/static/image/new/index/currency-icon5.png" class="icon" alt="">
          <img src="/static/image/new/index/currency-icon6.png" class="icon" alt="">
          <img src="/static/image/new/index/currency-icon7.png" class="icon" alt="">
        </div>
      </div>
      <div class="sponsor-container">
        <div class="container-head-box">
          <div class="title">{{ $t('赞助和博彩责任') }}</div>
          <div></div>
        </div>
        <div class="sponsor-list">
          <img src="/static/image/new/index/sponsor-icon1.png" class="icon" alt="">
        </div>
      </div>
      <div class="introduce-container">
        <div class="info">
          {{$t('introduce1')}}
        </div>
        <div class="info">
          {{$t('introduce2')}}
        </div>
        <div class="info">
          {{$t('introduce3')}}
        </div>
        <div class="info">
          {{$t('introduce4')}}
        </div>
        <div class="info">
          {{$t('introduce5')}}
        </div>
        <div class="info">
          {{$t('introduce6')}}
        </div>
      </div>
    </div>
    <div v-if="loading" class="loading-animation">
      <img src="/static/image/new/loading.gif" alt="">
    </div>
    <!-- 邀请弹窗   -->
    <van-popup v-model="invite_show" style="background: transparent">
      <div class="invite-popup">
        <div class="title">{{ $t('尊敬的NG娱乐会员:') }}</div>
        <div class="text" v-html="$store.state.appInfo.webcontent">

        </div>
        <div class="btn" @click="invite_show = false">{{ $t('我知道了') }}</div>
      </div>
    </van-popup>
    <!-- Safari下载弹窗   -->
    <van-popup v-model="Safari_show" position="bottom" :round="true" style="background: #212025;">
      <div class="Safari-popup">
        <div class="title-box">
          <span>{{ $t('如何安装') }}</span>
          <img src="/static/image/new/index/Safari-close.png" class="close-img" @click="Safari_show = false"  alt="">
        </div>
        <div class="download-step">{{ $t('1、使用Safar浏览器打开网站') }}</div>
        <div class="download-step">{{ $t('2、点击分享图标') }}</div>
        <img src="/static/image/new/index/Safari-icon.webp" class="download-step-img" alt="">
        <div class="download-step">{{ $t('3、选择“添加到主屏幕”') }}</div>
        <div class="step-add-info">
          {{ $t('添加到主屏幕') }}
          <img src="/static/image/new/index/Safari-add-icon.png" class="add-icon" alt="">
        </div>
      </div>
    </van-popup>

  </div>
</template>
<script>
import Swiper from "swiper/dist/js/swiper.js";
import "swiper/dist/css/swiper.min.css";
import { Toast } from 'vant';


import {getCurrentDay, translateText} from "../../common/utils";
import StorageExpire from '@/common/storageExpire.js'

export default {
  name: "index",
  data() {
    return {
      imgBase: 'https://api.n778.com/uploads/',
      bannerList: [],
      homeNoticeList: [],
      loading: false,
      bet_type: 'zuixin',
      bet_tab: [
        {
          type: 'zuixin',
          titleKey: '最新'
        },
        {
          type: '1day',
          titleKey: '日榜'
        },
        {
          type: '7day',
          titleKey: '周榜'
        },
        {
          type: '31day',
          titleKey: '月榜'
        }
      ],
      nav_type: 1,
      nav_list: [
        {
          type: 1,
          icon: require('../../../static/image/new/index/nav-icon1.png'),
          icon_active: require('../../../static/image/new/index/nav-icon1.png'),
          titleKey: 'PC彩票'
        },
        {
          type: 2,
          icon: require('../../../static/image/new/index/nav-icon2.png'),
          icon_active: require('../../../static/image/new/index/nav-icon2.png'),
          titleKey: '真人'
        },
        {
          type: 3,
          icon: require('../../../static/image/new/index/nav-icon3.png'),
          icon_active: require('../../../static/image/new/index/nav-icon3.png'),
          titleKey: '电子'
        },
        {
          type: 4,
          icon: require('../../../static/image/new/index/nav-icon4.png'),
          icon_active: require('../../../static/image/new/index/nav-icon4.png'),
          titleKey: '体育'
        },
        {
          type: 5,
          icon: require('../../../static/image/new/index/nav-icon5.png'),
          icon_active: require('../../../static/image/new/index/nav-icon5.png'),
          titleKey: '棋牌'
        }
      ],

      swiper_nav_index: 0,
      detail_status: false,

      time: 30 * 60 * 60 * 1000,

      invite_show: false,
      swiper: null,

      bet_list: {},


      sequence_info1: {},
      sequence_info2: {},
      sequence_info3: {},

      totalSeconds1: 180,
      totalSeconds2: 180,
      totalSeconds3: 180,

      timer1: null,
      timer2: null,
      timer3: null,

      time_interval1: null,
      time_interval2: null,
      time_interval3: null,

      timer: null,
      speed: 40, // 滚动速度(px/s)
      room_countdowns: {},

      rooms_list: [
        { type: 'one', code: 'jld28', img: '/static/image/new/index/room-item-bg3.png', titleKey: 'MI28', money: 20, min: 3},
        { type: 'two', code: 'jld28_5', img: '/static/image/new/index/room-item-bg4.png', titleKey: 'MI28', money: 50, min: 5 }
      ],
      slide_timer: false,


      download_show: false,
      Safari_show: false
    };
  },
  created() {
  },
  mounted() {
    if(Number(this.$store.state.appInfo.isclose) === 1) {
      this.invite_show = true
    }
    if(StorageExpire.get('download_show')) {
      this.download_show = false
    }
    // if(this.$store.state.token) {
      this.homeNotice()
    // }
    this.getBanList()

    this.$nextTick(() => {
      this.initSwiper()
      this.startScroll();
    })

  },
  methods: {
    async showTost(type, title) {
      const message = await translateText([title]);
      this.$parent.showTost(type, message[0]);
    },
    toast(text) {
      Toast(text)
    },
    handleHomeMenuClick(type) {
      if (type === 'pc28') {
        this.jumpRoomPage('/game-hall', 'one', 'jld28')
        return
      }
      if (type === 'liuhe') {
        this.jumpRoomPage('/game-Liuhe-room', 'one', 'xamlhc')
        return
      }
      this.toast(this.$t('即将上线，敬请期待'))
    },
    clickTab(type) {
      this.nav_type = type
      this.$forceUpdate()
    },
    handleClick(e) {
      let target = e.target.closest('.room-item')
      if (!target) return

      const type = target.dataset.type
      const room = target.dataset.room

      this.jumpRoomPage('/game-hall', type, room)
    },
    initSwiper() {
      this.swiper = new Swiper('.room-list', {
        slidesPerView: 2,
        spaceBetween:  5,
        slidesPerGroup: 1,
        loop: true,
        autoplay: {
          delay: 5000, // 自动切换（3秒）
          disableOnInteraction: false // 用户操作后仍然自动切换
        },
        preventClicks: false,
        preventClicksPropagation: false,
        touchStartPreventDefault: false
      });

      this.slide_timer = setInterval(() => {
        this.updateRoomCountdowns()

        const room = this.rooms_list.find(item => item.code === 'jld28')
        if (room && this.getRoomCountdownSeconds(room) < 3) {
          this.getSequenceNum3()
        }
      }, 1000);
      new Swiper(".mySwiper", {
        loop: true,
        speed: 500,
        slidesPerView: "auto",
        centeredSlides: true,
        spaceBetween: 0,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        freeMode: true,
      });
    },
    getRoomCountdownSeconds(item) {
      const duration = Math.max(Number(item.min) * 60, 0)
      const current = this.room_countdowns[item.code]
      if (!Number.isFinite(current)) return duration
      return Math.min(Math.max(current, 0), duration)
    },
    getRoomCountdown(item) {
      const totalSeconds = this.getRoomCountdownSeconds(item)
      return {
        hours: String(Math.floor(totalSeconds / 3600)).padStart(2, '0'),
        minutes: String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0'),
        seconds: String(totalSeconds % 60).padStart(2, '0')
      }
    },
    updateRoomCountdowns() {
      this.rooms_list.forEach(item => {
        const duration = Math.max(Number(item.min) * 60, 0)
        const current = this.getRoomCountdownSeconds(item)
        this.$set(this.room_countdowns, item.code, current > 0 ? current - 1 : duration)
      })

      // 更新所有 slide，包括 cloned slide
      const slides = document.querySelectorAll('.swiper-slide .countdown')
      slides.forEach(el => {
        const item = this.rooms_list.find(room => room.code === el.dataset.room)
        if (!item) return

        const countdown = this.getRoomCountdown(item)
        el.querySelector('.hours').textContent = countdown.hours
        el.querySelector('.minutes').textContent = countdown.minutes
        el.querySelector('.seconds').textContent = countdown.seconds
      })
    },
    initBannerSwiper() {
      new Swiper(".bannerSwiper", {
        loop: true,
        speed: 600,
        slidesPerView: 1,
        // centeredSlides: true,
        // autoHeight: true,
        autoplay: {
          delay: 6000, // 自动切换（8秒）
          disableOnInteraction: false // 关键：手动滑动后继续自动轮播
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        // 允许拖动
        allowTouchMove: true,
        // PC 鼠标也能拖
        simulateTouch: true,

        // observer: true,
        // observeParents: true
      });

    },
    getBanList() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post("/api/bannerList", {type: 2})
        .then((res) => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.bannerList = res.data;
            this.$nextTick(() => {
              that.initBannerSwiper()
            })
          }
          that.$parent.hideLoading();
        })
        .catch((res) => {
          that.$parent.hideLoading();
        });
    },
    homeNotice() {
      this.$apiFun.post("/api/homenotice", {}).then(async (res) => {
        if (res.code != 200) {
          this.showTost(0, res.message);
        }
        if (res.code == 200) {
          let list = res.data

          const text = await translateText(list)
          this.homeNoticeList = text

          this.getBetList()
          // 新澳门六合彩
          this.getSequenceNum1('xamlhc')
          // 香港六合彩
          this.getSequenceNum2('xglhc')
          // pc彩票
          this.getSequenceNum3('jld28')
        }
      });
    },
    // 最新投注列表
    getBetList() {
      if(!this.$store.state.token) return;
      this.$apiFun.post("api/game/touzhulist", {
        video: 'jld28',
        room: 'one'
      }).then(async (res) => {
        if (res.code != 200) {
          this.showTost(0, res.message);
        }
        if (res.code == 200) {
          let list = res.data
          this.bet_list = list
        }
      });
    },
    async go2(s, platname = '') {
      // this.$parent.goNav(`/gamePage?name=${s}&type=0&code=`);
      if (localStorage.getItem('token')) {
        // this.$parent.showTost(1, this.$t('加载中') + '...');
        const arr = ['AG', 'BG', 'PG', 'AGDZ','FB','KY']
        if(arr.includes(s)) return this.handleHomeMenuClick('comingSoon');
        this.loading = true
        this.goGamePage(s, 0, '', platname)
      } else {
        this.$router.push({path: '/login'});
      }
    },
    goGamePage(name, type = 0, code = '', platname) {
      return new Promise((resolve, reject) => {

        this.$apiFun
          .post('/api/getGameUrl', {plat_name: name, game_type: type || 0, game_code: code, is_mobile_url: 1})
          .then(res => {
            if (res.code != 200) {
              this.showTost(0, res.message);
            }
            if (res.code == 200) {
              // this.gameUrl[name] = res.data.url
              // this.$parent.goNav(`/gamePage?name=${s}&type=0&code=`);
              if (res.data.url) {
                this.opIframe(res.data.url, platname)
              }
            }
            this.loading = false
            resolve()
          })
          .catch(res => {
            this.loading = false
            reject()
          });
      })
    },
    opIframe(url, platname) {
      if (localStorage.getItem('token')) {
        this.$parent.goNav(`/gamePage?url=${encodeURIComponent(url)}&platname=${platname}`);
      } else {
        this.$router.push({path: '/login'});
      }
    },


    // 新澳门六合彩
    getSequenceNum1() {
      if(!this.$store.state.token) return;
      this.$apiFun
        .post('/api/game/ajaxSequencenum', {
          video_both: 'xamlhc',
          sequencenum_span: ''
        })
        .then(async (res) => {
          if (res.code !== 200) {
            this.showTost(0, res.data.message);
          }
          if (res.code === 200) {
            if(res.data && Object.keys(res.data).length > 0) {
              clearInterval(this.time_interval1)

              const info =  res.data
              info.outcome_arr = info.outcome.split('-')
              this.sequence_info1 = info


              const starttime = parseInt(info.sealing_plate)
              const fwq_time = parseInt(info.fwq_time)

              var elapsed = Math.floor((Date.now() -  Date.now()) / 1000);
              const nowtime = fwq_time + elapsed;

              // 剩余秒数
              const time = starttime - nowtime;
              this.totalSeconds1 = time * 1000
            }
          }
        })
        .catch(res => {
        });
    },
    onCountDownChange1(timeData) {
      if(timeData.milliseconds === 0) {
        this.time_interval1 && clearInterval(this.time_interval1)
        this.getSequenceNum1()
        this.time_interval1 = setInterval(() => {
          this.getSequenceNum1()
        }, 3000)
      }
    },
    // 香港六合彩
    getSequenceNum2() {
      if(!this.$store.state.token) return;
      this.$apiFun
        .post('/api/game/ajaxSequencenum', {
          video_both: 'xglhc',
          sequencenum_span: ''
        })
        .then(async (res) => {
          if (res.code !== 200) {
            this.showTost(0, res.data.message);
          }
          if (res.code === 200) {
            if(res.data && Object.keys(res.data).length > 0) {
              clearInterval(this.time_interval2)

              const info =  res.data
              info.outcome_arr = info.outcome.split('-')

              this.sequence_info2 = info


              const starttime = parseInt(info.sealing_plate)
              const fwq_time = parseInt(info.fwq_time)

              var elapsed = Math.floor((Date.now() -  Date.now()) / 1000);
              const nowtime = fwq_time + elapsed;

              // 剩余秒数
              const time = starttime - nowtime;
              this.totalSeconds2 = time * 1000
            }

          }
        })
        .catch(res => {
        });
    },
    onCountDownChange2(timeData) {
      if(timeData.milliseconds === 0) {
        this.time_interval2 && clearInterval(this.time_interval2)
        this.getSequenceNum2()
        this.time_interval2 = setInterval(() => {
          this.getSequenceNum2()
        }, 3000)
      }
    },
    // pc彩票
    getSequenceNum3() {
      if(!this.$store.state.token) return;
      this.$apiFun
        .post('/api/game/ajaxSequencenum', {
          video_both: 'jld28',
          sequencenum_span: ''
        })
        .then(async (res) => {
          if (res.code !== 200) {
            this.showTost(0, res.data.message);
          }
          if (res.code === 200) {
            if(res.data && Object.keys(res.data).length > 0) {
              clearInterval(this.time_interval3)

              const info =  res.data
              info.outcome_arr = info.outcome.split('-')

              this.sequence_info3 = info


              const starttime = parseInt(info.sealing_plate)
              const fwq_time = parseInt(info.fwq_time)

              var elapsed = Math.floor((Date.now() -  Date.now()) / 1000);
              const nowtime = fwq_time + elapsed;

              // 剩余秒数
              const time = starttime - nowtime;
              this.totalSeconds3 = time < 0 ? 0 : time
              const room = this.rooms_list.find(item => item.code === 'jld28')
              if (room) {
                this.$set(this.room_countdowns, room.code, this.totalSeconds3)
              }
            }
          }
        })
        .catch(res => {
        });
    },
    onCountDownChange3(timeData) {
      if(timeData < 3) {
        // 提前加载接口
        this.getSequenceNum3()
      }
      if(timeData === 0) {
        this.time_interval3 && clearInterval(this.time_interval3)
        this.getSequenceNum3()
        this.time_interval3 = setInterval(() => {
          this.getSequenceNum3()
        }, 3000)
      }
    },

    clearAllInterval() {
      clearInterval(this.time_interval1)
      this.time_interval1 = null
      clearInterval(this.time_interval2)
      this.time_interval2 = null
      clearInterval(this.time_interval3)
      this.time_interval3 = null
      clearInterval(this.timer);
      clearInterval(this.slide_timer)
      if (this.swiper) this.swiper.destroy();
    },
    jumpRoomPage(path, room, video) {
      this.$router.push({
        path: path,
        query: {
          room: room,
          game_video: video,
        }
      });
    },
    startScroll() {
      if (this.timer) return;

      let box = this.$refs.scrollBox;

      this.timer = setInterval(() => {
        box.scrollTop += 1;

        // 若滚动到原列表的高度，则重置 scrollTop 实现无缝循环
        if (box.scrollTop >= this.$refs.list1.offsetHeight) {
          box.scrollTop = 0;
        }
      }, 20);
    },

    pauseScroll() {
      clearInterval(this.timer);
      this.timer = null;
    },
    hideDownLoad() {
      this.download_show = false
      // 一天有效期
      StorageExpire.set('download_show', 'false', 86400);
    },
    jumpGameHall(key) {
      return this.handleHomeMenuClick('comingSoon');

      this.$router.push({
        path: '/game-hall',
        query: {
          category: key,
        }
      });
    }
  },
  updated() {
  },
  beforeDestroy() {
    this.clearAllInterval()
  },
  deactivated(){
    this.clearAllInterval()
  }
};
</script>
<style lang="scss">
.index-page {
  .swiper-game-container {
    .swiper-pagination-bullet {
      background: rgba(255, 255, 255, 0.6) !important;
      margin: 0 .15rem;
    }
    .swiper-pagination-bullet-active {
      background: #fff !important;
    }
  }

  .banner-box {
    .swiper-button-next, .swiper-button-prev {
      width: .7rem !important;
      height: .7rem !important;
    }
    .swiper-pagination {
      display: flex;
      align-items: center;
      justify-content: center;
      bottom: .4rem;
      left: 50%;
      transform: translateX(-50%);
      z-index: 10;
    }
    .swiper-pagination-bullet {
      margin: 0 .1rem !important;
      background: rgba(255, 255, 255, 0.3) !important;
    }
    .swiper-pagination-bullet-active {
      background: #D9D9D9 !important;
    }
  }

}
</style>
<style scoped lang="scss">
.index-page {
  width: 100%;
  height: 100vh;
  background-color: #000;
  color: #fff;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-bottom: 1.79rem;
  font-family: Inter;
  .download-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #222126;
    width: 100%;
    height: 1.76rem;
    padding: 0 .27rem 0 .35rem;
    box-sizing: border-box;
    .close-img {
      width: 0.32rem;
      margin-right: .56rem;
    }
    .download-left {
      display: flex;
      align-items: center;
    }
    .download-info {
      display: flex;
      align-items: center;
      .logo {
        width: 1.17rem;
        height: 1.17rem;
        margin-right: .16rem;
      }
      .title {
        font-size: 0.32rem;
      }
      .star-info {
        display: flex;
        align-items: center;
        font-size: 0.32rem;
        margin-top: .06rem;
        .star-list {
          margin-right: .16rem;
          img {
            width: 0.27rem;
            height: 0.27rem;
          }
        }
      }
      .desc {
        display: flex;
        align-items: center;
        margin-top: .08rem;
        img {
          width: 0.93rem;
        }
      }
    }
    .download-btn {
      width: 1.78rem;
      height: 0.77rem;
      background: radial-gradient( 50% 50% at 50% 85%, #B5BBF8 0%, #4B5BF1 100%);
      border-radius: 0.14rem;
      border: 0.02rem solid #9099EE;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0.29rem;
    }
  }
  .loading-animation{
    text-align: center;
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, .5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    img {
      width: 3.8rem;
      margin-top: -0.2rem;
    }
    .loading-text {
      height: 35px;
      margin-top: 151px;
      text-align: center;
    }
  }
  .content {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    width: 100%;
    .banner-box {
      width: 100%;
      //height: 14.13rem;
      position: relative;
      .header-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 1.55rem;
        padding: 0 .35rem;
        position: absolute;
        box-sizing: border-box;
        left: 0;
        right: 0;
        top: 0;
        z-index: 10;
        background: linear-gradient(
            to bottom,
            rgba(13, 13, 13, .9) 0%,
            rgba(13, 13, 13, 0.7) 50%,
            rgba(13, 13, 13, 0.4) 80%,
            rgba(13, 13, 13, 0) 100%
        );
        .logo {
          height: 1.39rem;
        }
        .btn-box {
          display: flex;
          align-items: center;
          .btn-item {
            width: 1.78rem;
            height: 0.77rem;
            border-radius: .14rem;
            overflow: hidden;
            margin-left: .29rem;
            padding: .02rem;

            .btn {
              background: rgba(255, 255, 255, 0.15);
              border: .02rem solid rgba(255, 255, 255, 0.1);
              color: #fff;
              display: flex;
              align-items: center;
              justify-content: center;
              width: 100%;
              height: 100%;
              border-radius: .5rem;
              font-size: .32rem;
            }
          }
        }
        .user-box {
          display: flex;
          align-items: center;
          .balance-info {
            background: rgba(255, 255, 255, 0.15);
            border: .02rem solid rgba(255, 255, 255, 0.1);
            height: .86rem;
            margin-right: .3rem;
            border-radius: .5rem;
            padding: 0 .1rem 0 .3rem;
            display: flex;
            align-items: center;
            font-weight: bold;
            font-size: .34rem;
            img {
              width: .64rem;
              margin-left: .2rem;
            }
          }
          .avatar {
            width: .85rem;
            height: .85rem;
            border-radius: 50%;
          }
        }
      }
      .swiper-list {
        width: 100%;
        position: relative;
        &::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          z-index: 8;
          height: .8rem;
          background: linear-gradient(
              to top,
              rgba(13, 13, 13, .6) 0%,
              rgba(13, 13, 13, 0.4) 60%,
              rgba(13, 13, 13, 0.2) 80%,
              rgba(13, 13, 13, 0) 100%
          );
        }
        .swiper-container {
          width: 100%;
        }
        .swiper-wrapper {
          align-items: stretch;
          .swiper-slide {
            height: auto !important;
            position: relative;
            display: flex;
            align-items: stretch;
            .banner-img {
              width: 100%;
              height: auto;
              display: block;
              object-fit: contain;   /* 不裁切 */
            }
            .banner-info {
              position: absolute;
              bottom: 1.1rem;
              left: .3rem;
              right: .3rem;
              z-index: 10;
              text-align: center;
              .banner-title {
                color: #fff;
                font-family: Poppins;
                font-weight: bold;
                font-size: .9rem;
                line-height: 1.01rem;
                text-align: center;
              }
              .banner-desc {
                color: rgba(255, 255, 255, 0.5);
                font-size: .45rem;
                font-family: PingFang SC;
                margin-top: .15rem;
              }
            }
          }
        }
      }
    }
    .card-box-bg {
      background: rgba(255,255,255,0.05);
      border: 0.03rem solid rgba(255,255,255,0.05);
      border-radius: .52rem;
      padding: 0 .13rem;
      margin: .27rem .21rem;
      position: relative;
      &::after {
        content: '';
        background: #002ED5;
        position: absolute;
        right: -0.5rem;
        bottom: 0rem;
        width: 2.32rem;
        height: 2.32rem;
        opacity: .6;
        filter: blur(1.4rem);
      }
    }
    .menu-list {
      margin: .4rem .3rem 0;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      position: relative;
      z-index: 2;
      .menu-item {
        width: 4.5rem;
        height: 1.45rem;
        margin-bottom: .24rem;
        position: relative;
        display: flex;
        align-items: center;
        padding: 0 1.1rem;
        background-size: 100% 100%;
        img {
          width: .44rem;
          position: absolute;
          left: .4rem;
          top: 50%;
          transform: translateY(-50%);
        }
        span {
          font-size: 0.41rem;
          position: relative;
          z-index: 2;
        }
      }
    }
    .notice-content {
      display: flex;
      align-items: center;
      background: rgba(255, 255, 255, 0.05);
      border-radius: .32rem;
      height: 1.28rem;
      border: 0.03rem solid rgba(255, 255, 255, 0.10);
      padding: 0 .51rem;
      position: relative;
      z-index: 2;
      margin-top: .4rem;
      .van-notice-bar {
        background: transparent !important;
      }
      .icon {
        width: 0.53rem;
        height: 0.53rem;
      }
      .notice-list {
        flex: 1;
        .notice-text {
          color: rgba(255,255,255,0.5);
          font-size: 0.37rem;
          font-family: Inter;
        }
      }
    }
    .balance-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 1.41rem;
      padding: 0 .37rem;
      position: relative;
      z-index: 2;
      .account {
        font-size: 0.43rem;
        color: #EAEAEA;
      }
      .balance {
        display: flex;
        align-items: center;
        font-size: 0.43rem;
        color: #EAEAEA;
        .refresh-icon {
          width: 0.75rem;
          height: 0.75rem;
          margin-left: .27rem;
        }
      }
    }
    .game-nav-list {
      display: flex;
      align-items: center;
      padding: 0 .21rem;
      overflow-x: auto;
      margin-top: .85rem;
      .nav-item {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 2.32rem;
        height: 0.85rem;
        color: #E8E8F6;
        font-size: 0.32rem;
        img {
          width: 0.43rem;
          margin-right: .16rem;
        }
        &.active {
          background: linear-gradient( 180deg, #2E0B71 0%, #7214D7 100%);
          box-shadow: inset 0rem 0.11rem 0.21rem 0rem rgba(94,83,142,0.2), inset 0rem -0.11rem 0.21rem 0rem rgba(94,83,142,0.2);
          border-radius: 0.11rem;
          color: #fff;
        }
      }
    }
    .nav-banner-content {
      margin-top: .53rem;
      padding: 0 .19rem;
      ul {
        width: 100%;
        li {
          width: 100%;
          margin-bottom: .27rem;
          position: relative;
          overflow: hidden;
          border-radius: .28rem;
          img {
            width: 100%;
            display: block;
          }
          .localized-image-copy {
            position: absolute;
            inset: 0 auto 0 0;
            width: 46%;
            box-sizing: border-box;
            padding: .35rem .3rem;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
            gap: .12rem;
            background: #080b18;
            color: #fff;
            strong {
              font-size: .62rem;
              line-height: 1;
              background: linear-gradient(90deg, #5c74ff, #a34df4);
              -webkit-background-clip: text;
              color: transparent;
            }
            span {
              color: #63a6ff;
              font-size: .25rem;
              letter-spacing: .03rem;
            }
            em {
              margin-top: .12rem;
              padding: .13rem .28rem;
              border-radius: .12rem;
              background: linear-gradient(90deg, #536af7, #6876ff);
              color: #fff;
              font-size: .28rem;
              font-style: normal;
            }
          }
        }
      }
    }
    .game-nav-content {
      height: 15.94rem;
      background-image: url("/static/image/new/index/lottery_bg_img.png");
      background-size: 100% 100%;
      margin-top: .65rem;
      padding-top: .91rem;
      position: relative;
      .game-nav-title {
        font-weight: bold;
        font-size: 0.88rem;
        text-align: center;
      }
      .lottery_bg2_img {
        width: 100%;
        position: absolute;
        left: 0;
        top: 1.35rem;
      }
      .room-list-wrapper {
        position: relative;
        z-index: 10;
      }
      .game-nav-desc {
        font-size: 0.41rem;
        color: rgba(255,255,255,0.5);
        text-align: center;
        margin-top: 0rem;
      }
      .room-list {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 6.27rem .72rem .4rem;
        pointer-events: auto !important;
        .room-item {
          width: 4.18rem;
          height: 4.85rem;
          position: relative;
          flex-shrink: 0;
          .bg {
            width: 100%;
            height: 100%;
          }
          .room-info {
            position: absolute;
            top: .4rem;
            left: .45rem;
            right: .45rem;
            .room-name {
              font-size: 0.4rem;
            }
            .money {
              font-weight: bold;
              font-size: 0.58rem;
              span {
                font-size: 0.9rem;
                background: linear-gradient(180deg, #FFFFFF 0%, #FFAA00 43.75%, #BE0000 100%);
                -webkit-background-clip: text;
                background-clip: text;
                -webkit-text-fill-color: transparent;
              }
            }
            .countdown {
              margin-top: .12rem;
              .colon {
                display: inline-block;
                color: rgba(255,255,255,0.5);
              }
              .block {
                display: inline-block;
                width: 0.65rem;
                height: 0.51rem;
                line-height: .51rem;
                border-radius: .09rem;
                color: #fff;
                font-size: 0.3rem;
                text-align: center;
                background: rgba(255,255,255,0.15);
              }
            }
          }
        }
      }
    }
    .swiper-banner-container {
      padding: 0 .43rem;
      margin-bottom: 1.1rem;
      position: relative;
      &::after {
        content: '';
        position: absolute;
        left: 0rem;
        top: 1.3rem;
        width: 4.92rem;
        height: 5.92rem;
        background: #651812;
        opacity: 1;
        filter: blur(1rem);
      }
      &::before {
        content: '';
        position: absolute;
        right: 0rem;
        top: 3rem;
        width: 3.92rem;
        height: 4.22rem;
        background: #651812;
        opacity: 1;
        filter: blur(1rem);
      }
      .banner-title {
        font-weight: bold;
        font-size: 0.88rem;
        text-align: center;
        z-index: 2;
      }
      .banner-desc {
        font-size: 0.41rem;
        color: rgba(255,255,255,0.5);
        text-align: center;
        margin-top: .1rem;
        position: relative;
        z-index: 2;
      }
      .swiper-box {
        height: 12.17rem;
        width: 100%;
        border-radius: 0.52rem;
        border: 0.03rem solid rgba(255,255,255,0.15);
        position: relative;
        z-index: 2;
        margin-top: .6rem;
        .cover {
          width: 100%;
          height: 100%;
        }
        .swiper-info {
          position: absolute;
          left: .59rem;
          right: .61rem;
          top: 8rem;
          display: flex;
          justify-content: space-between;
          .title {
            font-weight: bold;
            font-size: 0.73rem;
            color: #FFFFFF;
            font-family: Alibaba PuHuiTi;
          }
          .desc {
            font-size: 0.41rem;
            color: rgba(255,255,255,0.5);
          }
          .btn {
            width: 1.91rem;
            height: 1.01rem;
            background: rgba(255,255,255,0.1);
            border-radius: 0.52rem;
            border: 0.03rem solid rgba(255,255,255,0.1);
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 0.41rem;
            margin-top: .21rem;
          }
        }
        .swiper-list {
          position: absolute;
          bottom: .3rem;
          left: 0;
          right: 0;
          display: flex;
          align-items: center;
          overflow-x: auto;
          overflow-y: hidden;
          padding: 0 .34rem;
          margin-top: .43rem;
          .swiper-item {
            width: 1.75rem;
            height: 1.75rem;
            display: flex;
            align-items: center;
            justify-content: center;
            &:last-child {
              margin-right: 0;
            }
            &.active {
              border: .03rem solid rgba(255, 255, 255, 0.30);
              background: rgba(255, 255, 255, 0.05);
              box-shadow: 0rem .11rem .11rem 0 rgba(0, 0, 0, 0.15);
              border-radius: .31rem;
            }
            img {
              width: 1.28rem;
              height: 1.28rem;
            }
          }
        }
      }
    }
    .container-head-box {
      height: 1.24rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 .53rem;
      position: relative;
      z-index: 1;
      .title {
        font-size: 0.5rem;
        font-weight: bold;
      }
      .more-box {
        display: flex;
        align-items: center;
        height: 0.77rem;
        background: rgba(255,255,255,0.1);
        border-radius: 0.52rem 0.52rem 0.52rem 0.52rem;
        border: 0.03rem solid rgba(255,255,255,0.1);
        padding: 0 .32rem;
        font-size: 0.37rem;
      }
    }
    .game-type-container {
      margin-top: .2rem;
      position: relative;
      &.boxShadow::after {
        content: '';
        position: absolute;
        right: 0;
        top: .4rem;
        width: 2rem;
        height: 2rem;
        background: #00D56B;
        opacity: 1;
        filter: blur(1.8rem);
      }
      &.boxShadow2::after {
        content: '';
        position: absolute;
        right: -0.67rem;
        top: -0.2rem;
        width: 2.32rem;
        height: 1.84rem;
        background: #002ED5;
        opacity: .6;
        filter: blur(1.4rem);
      }
      &.boxShadow3::after {
        content: '';
        position: absolute;
        left: -1.17rem;
        bottom: -1rem;
        width: 2.53rem;
        height: 2.53rem;
        background: #D5004E;
        opacity: .5;
        filter: blur(1.4rem);
      }
      .game-list {
        display: flex;
        overflow-x: auto;
        padding: 0 .29rem;
        position: relative;
        z-index: 2;
        .game-item {
          margin-right: .13rem;
          .cover {
            width: 3.05rem;
            height: 4.27rem;
            border-radius: 0.22rem;
            overflow: hidden;
            position: relative;
            img {
              width: 100%;
              height: 100%;
            }
            .hot {
              position: absolute;
              left: 0;
              top: 0;
              background: #e4234e;
              padding: 0 .23rem;
              height: 0.42rem;
              line-height: .42rem;
              font-size: .27rem;
            }
            .title {
              position: absolute;
              left: .3rem;
              right: .3rem;
              bottom: .62rem;
              text-align: center;
              font-size: 0.53rem;
              font-family: BigruixianBlackGBV10;
              line-height: .6rem;
            }
          }
          .collect-info {
            display: flex;
            align-items: center;
            padding: .29rem 0;
            font-size: 0.3rem;
            font-weight: bold;
            .icon {
              width: .41rem;
              height: .41rem;
              margin-right: .1rem;
            }
          }
        }
      }
      .game-list2 {
        .game-item {
          .title {
            bottom: .43rem !important;
          }
        }
      }
    }
    .new-bet-container {
      padding: 0 .43rem;
      margin-top: 1.49rem;
      .container-title {
        font-weight: bold;
        font-size: 0.85rem;
        position: relative;
        text-align: center;
        &::after {
          content: '';
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 1.42rem;
          height: .01rem;
          background: linear-gradient(to right, #AF52DE, #FF5990, #FFCC00);
        }
        &::before {
          content: '';
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 1.42rem;
          height: .01rem;
          background: linear-gradient(to right, #FFCC00, #AF52DE, #5856D6);
        }
      }
      .container-desc {
        font-size: 0.41rem;
        color: rgba(255,255,255,0.5);
        text-align: center;
        margin-top: -0.1rem;
      }
      .bet-tab {
        display: flex;
        align-items: center;
        height: 1.33rem;
        background: rgba(255,255,255,0.05);
        border-radius: 2.13rem;
        border: 0.03rem solid rgba(255,255,255,0.05);
        padding: 0 .32rem;
        margin-top: .19rem;
        position: relative;
        &:after {
          content: '';
          width: 1.25rem;
          height: 0.51rem;
          background: linear-gradient( 235deg, #3A95FF 0%, rgba(58,149,255,0) 100%);
          filter: blur(12px);
          position: absolute;
          top: .16rem;
          left: 1.55rem;
          z-index: 1;
        }
        .tab-item {
          width: 2.13rem;
          height: 1.01rem;
          background: rgba(6,14,28,0.2);
          border-radius: 1.07rem;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 0.33rem;
          font-weight: bold;
          position: relative;
          &.active {
            border: 0.03rem solid rgba(255, 255, 255, 0.12);
          }
        }
      }
      .bet-table {
        position: relative;
        z-index: 2;
        .tr {
          padding: 0 .53rem 0 .21rem;
          .td {
            text-align: center;
            width: 20%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            &:first-child {
              width: 35%;
              text-align: left;
            }
            &:nth-child(2) {
              width: 25%;
            }
          }
        }
        .table-head {
          display: flex;
          align-items: center;
          margin: .32rem 0 .11rem;
          .td {
            font-size: 0.39rem;
            color: #999999;
          }
        }
        .table-wrapper {
          overflow: hidden;
          width: 100%;
        }
        .table-content {
          overflow: hidden;
          position: relative;
          height: auto;
          max-height: 10.84rem;
          .tr {
            height: 1.45rem;
            background: rgba(255,255,255,0.05);
            border-radius: 0.31rem;
            border: 0.03rem solid rgba(255,255,255,0.05);
            display: flex;
            align-items: center;
            margin-bottom: .11rem;
            &:nth-child(1) {
              background: linear-gradient( 180deg, rgba(255,204,0,0.15) 0%, rgba(255,204,0,0.1) 100%);
            }
            &:nth-child(2) {
              background: linear-gradient( 180deg, rgba(230,230,230,0.15) 0%, rgba(214,214,214,0.1) 100%);
            }
            &:nth-child(3) {
              background: linear-gradient( 180deg, rgba(187,121,78,0.15) 0%, rgba(187,121,78,0.1) 100%);
            }
            .td:nth-child(2) {
              font-weight: bold;
              font-size: 0.34rem;
            }
            .td:nth-child(3) {
              font-weight: bold;
              font-size: 0.32rem;
              color: #FFCC00;
            }
            .game-name-box {
              display: flex;
              align-items: center;
              padding-right: .1rem;
              .icon {
                width: 0.69rem;
                height: 0.69rem;
                border-radius: .08rem;
                margin-right: .11rem;
              }
              .name {
                flex: 1;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-size: 0.33rem;
              }
            }
            .rebate-box {
              display: flex;
              align-items: center;
              justify-content: flex-end;
              .value {
                flex: 1;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                text-align: right;
                font-weight: bold;
                font-size: 0.33rem;
                color: #98A7B5;
              }
              .icon {
                width: 0.42rem;
                height: 0.42rem;
                margin-left: .06rem;
              }
            }
          }
        }
      }
    }
    .poker-container {
      margin-top: .5rem;
      position: relative;
      &:after {
        content: '';
        position: absolute;
        left: -1.39rem;
        top: 0rem;
        width: 4.69rem;
        height: 3.29rem;
        background: #00D56B;
        opacity: 0.6;
        filter: blur(2.6rem);
        z-index: 1;
      }
      .poker-banner-img {
        width: 9.85rem;
        height: 5.27rem;
        display: inline-block;
        padding: 0 .27rem;
        position: relative;
        z-index: 2;
        img {
          width: 100%;
          height: 100%;
        }
        .title {
          position: absolute;
          left: 0.3rem;
          right: 0.3rem;
          top: 50%;
          transform: translateY(-50%);
          text-align: center;
          font-size: 1.07rem;
          font-family: BigruixianBlackGBV10;
        }
      }
    }
    .game-lottery-container {
      margin-top: .3rem;
      position: relative;
      &:after {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 2.2rem;
        height: 2.2rem;
        background: #D59200;
        opacity: 1;
        filter: blur(1.9rem);
      }
      &:before {
        content: '';
        position: absolute;
        right: -0.6rem;
        bottom: -1rem;
        width: 2.35rem;
        height: 2.35rem;
        background: #D59200;
        filter: blur(1.6rem);
      }
      .lottery-list {
        display: flex;
        align-items: center;
        overflow-x: auto;
        padding: 0rem 0 .27rem .37rem;
        position: relative;
        z-index: 2;
        .lottery-item {
          width: 4.71rem;
          height: 5.93rem;
          background-size: 100% 100%;
          padding: .21rem .28rem;
          margin-right: .1rem;
          box-sizing: border-box;
          flex-shrink: 0;
          .info {
            display: flex;
            align-items: center;
            .logo {
              width: 1.01rem;
              height: 1.01rem;
              margin-right: .16rem;
            }
            .title {
              font-size: 0.39rem;
            }
            .desc {
              font-size: 0.33rem;
            }
          }
          .start-time-title {
            font-size: 0.27rem;
            margin-top: .53rem;
          }
          .countDown {
            margin-top: .29rem;
            .block-bg {
              width: 1.14rem;
              height: 1.39rem;
              background: linear-gradient(190deg, rgba(111, 89, 0, 1), rgba(111, 89, 0, 0));
              padding: .03rem;
              display: inline-block;
              border-radius: .21rem;
              .block {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: 100%;
                border-radius: .21rem;
                color: #fff;
                font-size: 0.38rem;
                text-align: center;
                background: rgba(6,14,28,0.43);
                line-height: .4rem;
                em {
                  font-style: normal;
                  font-size: .24rem;
                }
              }
            }

          }
          .bet-btn {
            background: #FFCC00;
            height: 0.85rem;
            border-radius: .16rem;
            margin-top: .61rem;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 0.34rem;
            color: #000;
            font-weight: bold;
          }
        }
      }
    }
    .game-owner-container {
      margin-top: .3rem;
      position: relative;
      z-index: 2;
      .owner-list {
        display: flex;
        align-items: center;
        overflow-x: auto;
        padding: 0 .37rem .3rem;
        .owner-item {
          flex-shrink: 0;
          width: 7.54rem;
          height: 5.1rem;
          background: linear-gradient(to bottom, rgba(255, 204, 0, 0.15), rgba(255, 204, 0, 0.10));
          border: .03rem solid rgba(255, 255, 255, 0.05);
          border-radius: .31rem;
          position: relative;
          margin-right: .27rem;
          &:last-child {
            margin-right: 0;
          }
          .more-btn {
            width: 1.23rem;
            height: 0.37rem;
            background: rgba(255,255,255,0.1);
            border-radius: 0.26rem;
            border: 0.01rem solid rgba(255,255,255,0.1);
            font-size: 0.19rem;
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            top: .24rem;
            right: .48rem;
          }
          .info {
            display: flex;
            align-items: center;
            padding: .24rem 1.8rem .34rem .43rem;
            .logo {
              height: .44rem;
              margin-right: .3rem;
            }
            .title {
              font-size: 0.27rem;
            }
            .num {
              font-size: 0.3rem;
              color: #97A8B8;
            }
          }
          .cover-list {
            display: flex;
            flex-wrap: wrap;
            .img {
              width: 2.3rem;
              height: 1.66rem;
              border-radius: .21rem;
              margin-left: .16rem;
              margin-bottom: .16rem;
            }
          }
        }
      }
    }
    .swiper-game-container {
      text-align: center;
      padding-top: 1.4rem;
      padding-bottom: 1.4rem;
      position: relative;
      &:after {
        content: '';
        position: absolute;
        left: 0rem;
        top: 2.9rem;
        width: 3.8rem;
        height: 3.8rem;
        background: #3e3d95;
        opacity: 1;
        filter: blur(1.1rem);
      }
      &:before {
        content: '';
        position: absolute;
        right: -1.1rem;
        top: 3.7rem;
        width: 3.2rem;
        height: 3.2rem;
        background: #3e3d95;
        opacity: 1;
        filter: blur(1.1rem);
      }
      .swiper-title {
        font-weight: bold;
        font-size: 0.88rem;
      }
      .swiper-desc {
        font-size: 0.41rem;
        color: rgba(255,255,255,0.5);
      }
      .swiper-list {
        width: 100%;
        position: relative;
        z-index: 2;
        margin-top: .67rem;
        .swiper-container{
          width: 100%;
          height: 10rem;
          position: relative;
          z-index: 10;
          .swiper-slide {
            width: 7.09rem;
            height: 9.47rem;
            position: relative;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .swiper-slide-active {
            z-index: 2;
          }
          .swiper-slide-prev {
            transform: rotate(-10deg);
            margin-top: .5rem;
            &::after{
              content: '';
              width: 100%;
              height: 100%;
              background: linear-gradient( 180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.8) 50%, #000000 100%);
              position: absolute;
              top: 0;
              left: 0;
            }
          }
          .swiper-slide-next {
            transform: rotate(10deg);
            margin-top: .5rem;
            &::after{
              content: '';
              width: 100%;
              height: 100%;
              background: linear-gradient( 180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.8) 50%, #000000 100%);
              position: absolute;
              top: 0;
              left: 0;
            }
          }
        }

        .swiper-controls {
          height: 0.83rem;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          .swiper-pagination {
            position: relative !important;
            margin: .2rem .6rem 0;
          }
          .custom-prev,
          .custom-next {
            width: 0.83rem;
            height: 0.83rem;
            background-size: cover;
            position: relative !important; /* 去除 Swiper 默认 absolute */
          }
          .custom-prev {
            background-image: url('/static/image/new/index/prev.png');
          }
          .custom-next {
            background-image: url('/static/image/new/index/next.png');
          }
          /* 去掉默认箭头 */
          .swiper-button-prev::after,
          .swiper-button-next::after {
            display: none;
          }
        }
      }
    }
    .detail-container {
      padding-bottom: 1.35rem;
      position: relative;
      &:after {
        content: '';
        position: absolute;
        left: -1.39rem;
        top: 0rem;
        width: 4.2rem;
        height: 2rem;
        background: #D59200;
        opacity: .55;
        filter: blur(1.6rem);
        z-index: 2;
      }
      .detail-box {
        padding: .5rem .48rem 0;
        position: relative;
        &.shadow {
          &::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            height: 100%;
            background: linear-gradient(to bottom, rgba(0,0,0,0.5) 10%, rgba(0,0,0,0.9));
            z-index: 1;
          }
        }
        .detail-content {
          font-size: 0.39rem;
          color: #999999;
        }
        .detail-more {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          margin: auto;
          width: 2.88rem;
          height: 1.11rem;
          padding: 0.03rem;
          background: linear-gradient(190deg, rgba(116, 180, 255, 1), rgba(50, 111, 182, 0));
          border-radius: 1.07rem;
          z-index: 2;
          &.open-more {
            bottom: -1.35rem;
          }
          .btn {
            background: rgba(6,14,28,0.8);
            border-radius: 1.07rem;
            height: 100%;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 0.33rem;
          }
        }
      }

    }
    .law-container {
      border-bottom: .03rem solid #25272B;
      padding-bottom: .72rem;
      position: relative;
      &:after {
        content: '';
        position: absolute;
        right: -0.85rem;
        top: .8rem;
        width: 3.52rem;
        height: 2.6rem;
        background: rgba(134,5,198,0.6);
        opacity: .6;
        filter: blur(1.3rem);
      }
      .law-list {
        padding: 0 .53rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .law-item {
          font-size: 0.33rem;
          color: #999999;
          position: relative;
          z-index: 2;
        }
      }
    }
    .currency-container {
      margin-top: .5rem;
      position: relative;
      &:after {
        content: '';
        position: absolute;
        left: -0.85rem;
        top: .8rem;
        width: 3.5rem;
        height: 2.6rem;
        background: rgba(134,5,198,0.6);
        opacity: .6;
        filter: blur(1.3rem);
      }
      .currency-list {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 .45rem;
        margin-top: .1rem;
        position: relative;
        z-index: 2;
        .icon {
          width: 1.07rem;
          height: 1.07rem;
        }
      }
    }
    .sponsor-container {
      margin-top: .5rem;
      position: relative;
      &:after {
        content: '';
        position: absolute;
        right: -0.85rem;
        top: .8rem;
        width: 3.5rem;
        height: 2.6rem;
        background: rgba(134,5,198,0.6);
        opacity: .6;
        filter: blur(1.3rem);
      }
      .sponsor-list {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 .45rem;
        margin-top: .1rem;
        .icon {
          height: 1.28rem;
        }
      }
    }
    .introduce-container {
      border-top: .03rem solid #25272B;
      padding: 1.87rem .45rem .1rem;
      margin-top: .88rem;
      .info {
        font-size: 0.28rem;
        color: #999999;
        line-height: 0.53rem;
        margin-bottom: .21rem;
      }
    }
  }
  .invite-popup {
    background-image: url("/static/image/new/index/popup-bg.png");
    background-size: 100% 100%;
    width: 8.64rem;
    height: 11.68rem;
    padding: 6.08rem .53rem .85rem;
    font-family: PingFang SC;
    display: flex;
    flex-direction: column;
    .title {
      font-weight: bold;
      font-size: 0.43rem;
    }
    .text {
      font-size: 0.37rem;
      margin-top: .27rem;
      flex: 1;
      overflow-y: auto;
    }
    .btn {
      height: 1.23rem;
      border-radius: .6rem;
      background: linear-gradient(to bottom, #4B5BF1 40%, #B5BBF8);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0.43rem;
      font-weight: bold;
      margin-top: .53rem;
    }
  }
  .Safari-popup {
    width: 100%;
    padding: .64rem .37rem 1.09rem;
    .title-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      span {
        font-size: 0.43rem;
        font-weight: bold;
      }
    }
    .download-step {
      font-weight: 600;
      font-size: 0.37rem;
      margin-top: .9rem;
    }
    .download-step-img {
      width: 100%;
    }
    .step-add-info {
      width: 100%;
      height: 1.29rem;
      background: #2C2D32;
      border-radius: 0 .7rem .7rem 0;
      margin-top: .27rem;
      position: relative;
      display: flex;
      align-items: center;
      font-size: 0.37rem;
      padding: 0 .43rem;
      img {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: -0.3rem;
        width: 1.9rem;
        height: 1.9rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mode/index.vue